import type { FetchTicketResponse } from "src/api/models";
import type { MenuItem } from "../types";

export function createArticleMenuItem(
  ticket: FetchTicketResponse,
  showAddArticleDialog: () => void
): MenuItem {
  return {
    label: "Add Article",
    icon: "pi pi-plus-circle",
    command: () => {
      showAddArticleDialog();
    }
  };
}
